<!-- Chat Button -->
<button pButton class="chat-button" (click)="toggleDrawer()">
    <i class="pi pi-comments"></i>
</button>

<!-- Chat Box -->
<div class="chat-box" [class.open]="isOpen" *ngIf="isOpen">
    <div class="chat-header p-bg-primary p-text-primary">
        <span class="chat-title">Front Office Method</span>
        <button class="close-btn" (click)="toggleDrawer()">✕</button>
    </div>    
    <iframe 
        src="https://copilotstudio.microsoft.com/environments/Default-d4c909fc-3627-49a6-b36c-45582caf3469/bots/crf1c_mustangMoneyBall/webchat?__version__=2" 
        frameborder="0" 
        style="width: 100%; height: 100%;">
    </iframe>
</div>